import { AU_STRIPE_KEY, GB_STRIPE_KEY, GLOBAL_STRIPE_KEY } from "core/config/config";

/**
 * AU stripe key is used as global market.
 */
export const PUBLIC_KEYS = [
    { country: 'default', key: AU_STRIPE_KEY },
    { country: 'nz', key: GLOBAL_STRIPE_KEY },
    { country: 'gb', key: GB_STRIPE_KEY },
];